import React from 'react';
import css from './css.module.less';
import { Form, OriCheckbox } from 'src/components/Antd';
import SectionWrapper from '@/src/pages/SalesCannelVersion/Components/SectionWrapper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;
const firstCheckbox = ['usageLimitation', 'combinedWithVoucher'];
const secondCheckbox = ['usageLimitation', 'combinedWithPromotion'];

const UsageLimitation = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  return (
    <SectionWrapper
      title={getI18n('voucher.storeVoucherDetail.usageLimitation')}
      containerClassName={css.container}>
      <Item
        name={firstCheckbox}
        valuePropName={'checked'}
        className={css.firstCheckbox}>
        <OriCheckbox disabled={disabled}>
          {getI18n('voucher.storeVoucherDetail.vouchercannotcombine1')}
        </OriCheckbox>
      </Item>
      <Item name={secondCheckbox} valuePropName={'checked'}>
        <OriCheckbox disabled={disabled}>
          {getI18n('voucher.storeVoucherDetail.vouchercannotcombine2')}
        </OriCheckbox>
      </Item>
    </SectionWrapper>
  );
};
export default UsageLimitation;
